import gql from 'graphql-tag';

export const CustomIntegrationFragment = gql`
  fragment CustomIntegrationFragment on CustomIntegration {
    id
    accountName
    accountUrl
    provider
    tenantId
    active
    createdAt
    updatedAt
    policy {
      update
      createMember
      read
    }
  }
`;

export const OauthIntegrationFragment = gql`
  fragment OauthIntegrationFragment on OauthIntegration {
    id
    accountName
    accountUrl
    provider
    tenantId
    active
    createdAt
    updatedAt
    policy {
      update
      createMember
      read
    }
  }
`;

export const ShareFileIntegrationFragment = gql`
  fragment ShareFileIntegrationFragment on ShareFileIntegration {
    id
    accountName
    accountUrl
    provider
    tenantId
    active
    createdAt
    updatedAt
    policy {
      update
      createMember
      read
    }
  }
`;
